import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';

const EpisodeAuditPanel = ({
  episodeCreatedby,
  episodedDateCreate,
  episodeEditedby,
  episodedDateEdit
}) => {

  // Helper function to format date from 'YYYY-MM-DDT00:00:00' to 'MM/DD/YYYY hh:mm A'
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return moment(dateString).format('MM/DD/YYYY hh:mm A');
  };

  // Helper function to get user name from json object
  const getUserName = (userObj) => {
    if (!userObj || !userObj.value) return 'N/A';
    return userObj.value;
  };

  return (
    <Box
      sx={{
        backgroundColor: '#f5f5f5',
        padding: '8px 16px',
        borderTop: '1px solid #e0e0e0',
        marginTop: '16px'
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.875rem',
          color: '#666'
        }}
      >
        <strong>Episode created by:</strong> {getUserName(episodeCreatedby)} on {formatDate(episodedDateCreate)}
        {' | '}
        <strong>Edited by:</strong> {getUserName(episodeEditedby)} on {formatDate(episodedDateEdit)}
      </Typography>
    </Box>
  );
};

export default EpisodeAuditPanel;
